<script>
    import { sendAnalytics } from "@/core/SendAnalytics";
    import BaseInput from "@main/packages/BaseInput";

    export default {
        name: "PromocodeEmail",
        components: { BaseInput },
        data() {
            return {
                email: "",
                errorSubmit: "",
                successSubmit: false,
                isSubmitted: false,
            };
        },
        watch: {
            email() {
                this.errorSubmit = "";
            },
        },
        methods: {
            sendForm() {
                if (this.isSubmitted) {
                    return;
                }

                if (this.email.length < 1) {
                    this.errorSubmit = "Поле обязательно для заполнения";
                    return;
                }

                this.isSubmitted = true;
                this.errorSubmit = "";

                this.$store.formApi
                    .subscribeUserByAction({ email: this.email.trim() })
                    .then((res) => {
                        if (res.success) {
                            this.successSubmit = true;
                            sendAnalytics.send(sendAnalytics.events.subscribe);
                            return;
                        }

                        if (
                            res.error.includes(this.email) ||
                            res.error === "Такой email-адрес уже есть в базе"
                        ) {
                            this.errorSubmit = "Упс! Этот адрес уже получает рассылки";
                        }

                        if (res.error === "Некорректный email-адрес") {
                            this.errorSubmit = res.error;
                        }
                    });

                setTimeout(() => {
                    this.isSubmitted = false;
                }, 1200);
            },
        },
    };
</script>

<template>
    <div class="promocode-email">
        <div class="l-container">
            <div
                class="promocode-email__form"
                :class="{ 'promocode-email__form--success': successSubmit }"
            >
                <h2 class="promocode-email__form-title promocode__title">
                    Скидка 15%<br />для новых подписчиков
                </h2>
                <div class="promocode-email__form-desc">
                    Подпишитесь на нашу рассылку, чтобы получить скидку 15% на первый заказ.
                </div>
                <div class="promocode-email__form-desc">
                    Сразу после подписки мы пришлем на почту персональный промокод. И раз в
                    месяц будем дарить новые скидки и делиться новостями.
                </div>
                <div class="promocode-email__form-box">
                    <form class="promocode-email__form-wrap" @submit.prevent="sendForm">
                        <base-input
                            v-model="email"
                            placeholder="Электронная почта"
                            :error-text="errorSubmit"
                        ></base-input>
                        <button type="submit" class="promocode-email__form-button outline">
                            <img src="/static/xd-design/icons/email.svg" alt="" />
                        </button>
                    </form>
                    <div class="promocode-email__form-agreement">
                        Нажимая на кнопку, вы даете согласие на обработку своих
                        <a target="_blank" href="/document-personal">персональных данных</a>
                    </div>
                    <div class="promocode-email__form-success">
                        Промокод отправлен, проверьте почту
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .promocode-email {
        position: relative;
        margin-top: 30px;
        padding: 24px 0 40px;
        background: url("/static/xd-design/promocode/promocode-email-bg--mobile.jpg");
        background-size: cover;
        height: 496px;

        &:after {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: linear-gradient(
                274.49deg,
                rgba(0, 0, 0, 0.7) 60.01%,
                rgba(0, 0, 0, 0.1365) 86.94%,
                rgba(0, 0, 0, 0) 107.89%
            );
            transform: rotate(-180deg);
        }

        @include bp($bp-tablet-md) {
            margin-top: 54px;
            padding: 40px;
            height: 637px;
            background: url("/static/xd-design/promocode/promocode-email-bg.jpg");
            background-size: cover;
            &:after {
                background: linear-gradient(
                    274.27deg,
                    rgba(0, 0, 0, 0.55) 47.81%,
                    rgba(0, 0, 0, 0.1365) 63.21%,
                    rgba(0, 0, 0, 0) 75.19%
                );
            }
        }
        @include bp($bp-desktop-xxl) {
            background-image: url("/static/xd-design/promocode/promocode-email-bg--large.jpg");
        }
    }

    .promocode-email__form-title {
        position: relative;
        margin-bottom: 12px;
        z-index: 1;

        @include bp($bp-tablet-md) {
            margin-bottom: 16px;
        }

        &.promocode__title {
            color: #fff;
        }
    }

    .promocode-email__form-desc {
        position: relative;
        max-width: 240px;
        font-size: 14px;
        line-height: 26px;
        color: #fff;
        margin-bottom: 16px;
        z-index: 1;

        @include bp($bp-tablet-md) {
            max-width: 100%;
            font-size: 16px;
        }
    }

    .promocode-email__form {
        position: relative;
        padding: 8px;
        z-index: 1;

        @include bp($bp-tablet-md) {
            max-width: 572px;
            padding: 36px 16px;
        }
    }

    .promocode-email__form-wrap {
        position: relative;
        input {
            background-color: #fff;
            &::placeholder {
                color: #e4e4eb;
            }
        }
    }

    .promocode-email__form-button {
        position: absolute;
        top: 14px;
        right: 14px;
        height: 24px;

        @include bp($bp-desktop-sm) {
            top: 19px;
        }

        &:after {
            content: "";
            position: absolute;
            top: -5px;
            left: -5px;
            right: -5px;
            bottom: -5px;
        }
    }

    .promocode-email__form-agreement {
        margin-top: 8px;
        font-weight: 500;
        font-size: 12px;
        line-height: 22px;
        color: #fff;

        a {
            color: #0083db;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .promocode-email__form-box {
        position: relative;
    }

    .promocode-email__form-success {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 16px;
        line-height: 26px;
        color: var(--success);
        opacity: 0;
        background-color: #fff;
        padding: 14px 24px;
        white-space: nowrap;
        pointer-events: none;
    }

    //
    // --mod
    //

    .promocode-email__form--success {
        .promocode-email__form-agreement {
            opacity: 0;
        }

        .promocode-email__form-wrap {
            opacity: 0;
        }

        .promocode-email__form-success {
            opacity: 1;
            pointer-events: auto;
        }
    }
</style>
